import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminDataFeedProducts from "@/pages/admin/AdminDataFeedProducts";

export const Route = createFileRoute("/admin/data-feeds/$id/products")({
  component: () => (
    <ProtectedRoute>
      <AdminDataFeedProducts />
    </ProtectedRoute>
  ),
});
